import { FileUploadBtn } from "./fileUploadBtn"

const MedicalFileUploadBtn = ({isDisabled=false, isBorder =false}) => {
  let text = "Upload Records / Bills";
  if(isBorder){
    if(isDisabled){
      text = "Provider Name Already Exists"
    }else{
      text = "Upload Medical Records / Bills"
    }
  }
  
  return (
    <FileUploadBtn isDisabled={isDisabled} text={text} isBorder={isBorder}/>  
  )
}

export default MedicalFileUploadBtn;